// extracted by mini-css-extract-plugin
export default {"box":"bottom_box__+rwnw"};